import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Modal, Row, Button, Space } from 'antd';
import { CloseOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { DataGridPlus, TablesFilter } from 'components/common';

import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';
import { getWarehouseCodeFromCache } from 'utils';

type Props = {
  onHide: () => void;
  onOk: (selectedPo: PoRow) => void;
  poList: PoRow[];
};
// eslint-disable-next-line
export default (props: Props) => {
  const { onHide, poList, onOk } = props;
  const [filteredData, setFilteredData] = useState<any[]>([]);
  // const [selected, setSelected] = useState<PoRow>();

  const history = useHistory();

  const defaultWarehouseCode = getWarehouseCodeFromCache(
    Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY))
  );

  /**
   * handle hide event
   */
  const handleHide = useCallback(() => {
    onHide();
  }, [onHide]);

  const columns = [
    {
      header: 'PO#',
      name: 'poNumber',
      userSelect: true,
      defaultFlex: 1,
    },
    {
      header: 'PO Warehouse',
      name: 'warehouseCode',
      userSelect: true,
      defaultFlex: 1,
    },
    {
      header: 'Container #',
      name: 'container',
      userSelect: true,
      defaultFlex: 1,
    },
    {
      header: 'Supplier',
      name: 'vendorName',
      userSelect: true,
      defaultFlex: 1,
    },
  ];

  // eslint-disable-next-line
  const onRowClick = (row: any) => {
    //console.log('rd', defaultWarehouseCode, row.data);
    if (row.data.warehouseCode !== defaultWarehouseCode) {
      Modal.confirm({
        cancelText: 'No',
        centered: true,
        content: 'PO warehouse doesn’t match your default warehouse, do you want to switch the warehouse?',
        icon: <ExclamationCircleOutlined />,
        okText: 'Yes',
        onOk() {
          history.push('/administration/settings');
        },
        onCancel() { onOk(row.data); },
      });
    } else {
      onOk(row.data);
    }
  };

  return (
    <Modal
      title="Purchase Order Receiving"
      centered
      visible={true}
      width={800}
      destroyOnClose={true}
      onCancel={handleHide}
      getContainer={false}
      footer={
        <Row justify="end">
          <Space>
            <Button onClick={handleHide} icon={<CloseOutlined />}>Cancel</Button>
          </Space>
        </Row>
      }
    >
      <TablesFilter
        columns={columns}
        dataSource={poList}
        setFilteredData={setFilteredData}
      />
      <DataGridPlus
        columns={columns}
        onRowClick={(row) => {
          onOk(row.data);
        }}
        //onRowClick={onRowClick}
        dataSource={filteredData}
        idProperty="poNumber"
        pagination="local"
        {...({} as any)}
      />
    </Modal>
  );
};
